import React from 'react';
import { motion } from 'framer-motion';
import { Download, Leaf, Sparkles } from 'lucide-react';
export function HowItWorks() {
  const steps = [{
    icon: <Download size={28} data-id="element-107" />,
    title: 'Descarga',
    desc: 'Recibes el acceso instantáneo a tu guía en PDF para verla en cualquier dispositivo.'
  }, {
    icon: <Leaf size={28} data-id="element-108" />,
    title: 'Prepara',
    desc: 'Consigues ingredientes simples y naturales (muchos ya están en tu cocina).'
  }, {
    icon: <Sparkles size={28} data-id="element-109" />,
    title: 'Transforma',
    desc: 'Aplicas la receta seleccionada siguiendo el Protocolo del Triángulo Maestro y sientes el cambio inmediato.'
  }];
  return <section className="py-24 px-4 bg-botanical-ivory" data-id="element-110">
      <div className="max-w-5xl mx-auto" data-id="element-111">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="text-center mb-16" data-id="element-112">
          <h2 className="text-3xl md:text-4xl font-playfair text-botanical-forest mb-4" data-id="element-113">
            Tu ritual en 3 pasos simples
          </h2>
          <div className="w-24 h-px bg-botanical-sage mx-auto" data-id="element-114"></div>
        </motion.div>

        <div className="flex flex-col md:flex-row justify-between items-start relative gap-12 md:gap-4" data-id="element-115">
          {/* Connecting dashed line for desktop */}
          <div className="hidden md:block absolute top-12 left-[10%] right-[10%] h-px border-t-2 border-dashed border-botanical-sage/30 z-0" data-id="element-116"></div>

          {steps.map((step, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: index * 0.2
        }} className="flex-1 text-center relative z-10 w-full" data-id="element-117">
              <div className="w-24 h-24 mx-auto bg-white rounded-full flex items-center justify-center mb-6 border border-botanical-sage/30 shadow-sm text-botanical-forest relative" data-id="element-118">
                <div className="absolute -top-2 -right-2 w-8 h-8 bg-botanical-gold text-white rounded-full flex items-center justify-center font-playfair font-bold text-lg" data-id="element-119">
                  {index + 1}
                </div>
                {step.icon}
              </div>
              <h3 className="text-2xl font-playfair text-botanical-forest mb-4" data-id="element-120">
                {step.title}
              </h3>
              <p className="text-botanical-forest/80 font-lora px-4" data-id="element-121">
                {step.desc}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}